import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const useUnsavedChanges = (hasChanges) => {
  const navigate = useNavigate();
  const hasChangesRef = useRef(false);
  const pendingNav = useRef(null);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    hasChangesRef.current = hasChanges;
  }, [hasChanges]);

  // Chặn reload
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasChangesRef.current) { e.preventDefault(); e.returnValue = ''; }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  // Chặn sidebar/bottom nav
  useEffect(() => {
    const handleBeforeNavigate = (e) => {
      const { to } = e.detail;
      if (hasChangesRef.current) {
        if (window.__blockNavigation) window.__blockNavigation();
        pendingNav.current = to;
        setShowConfirm(true);
      }
    };
    window.addEventListener('beforeNavigate', handleBeforeNavigate);
    return () => window.removeEventListener('beforeNavigate', handleBeforeNavigate);
  }, []);

  const confirmLeave = () => {
    setShowConfirm(false);
    const to = pendingNav.current;
    pendingNav.current = null;
    // ✅ KHÔNG reset hasChangesRef - để back button vẫn hoạt động
    if (to) navigate(to);
  };

  const confirmStay = () => {
    setShowConfirm(false);
    pendingNav.current = null;
  };

  return { showConfirm, confirmLeave, confirmStay, pendingNav };
};

export default useUnsavedChanges;